import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfig } from 'src/app/app.config';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json;', 'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
    Accept: 'q=0.8;application/json;q=0.9'
  })
};
@Injectable({
  providedIn: 'root'
})
export class ChartService {
  headers: Headers;

  // private apiURL = 'http://207.244.230.78:63101/';
  // private apiURL = 'http://197.243.20.164/';
  private apiURL = this.config.apiUrl;

  constructor(
    private httpClient: HttpClient,
    private config: AppConfig,
  ) { }

  getGenderBeneficiaries(): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + 'Chart/GetGenderBeneficiaries')
      .pipe(
        catchError(this.handleErrors)
      )
  }


  getComponentBugdet(): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + 'Chart/GetComponentBugdet')
      .pipe(
        catchError(this.handleErrors)
      )
  }

  getActivitiesSubcomponent(): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + 'Chart/GetActivitiesSubcomponent')
      .pipe(
        catchError(this.handleErrors)
      )
  }

  getActivitiesStatusStatistics(): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + 'Chart/GetActivitiesStatusStatistics')
      .pipe(
        catchError(this.handleErrors)
      )
  }

  getHomeStatistics(): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + 'Chart/GetTotals')
      .pipe(
        catchError(this.handleErrors)
      )
  }


  private handleErrors(error: HttpErrorResponse): Observable<any> {
    if (error.status > 0) {
      if (error.status > 0) {
        if (error.status === 401) {
          return throwError('Unauthorized');
        } else if (error.status === 500) {
          return throwError('Contact your administrator');
        }
        else if (error.status === 400) {
          console.log(error.error);
          if (error.error === 'Request not approved .') {
            return throwError(error.error);
          } else {
            return throwError('Format or mandatory field error.');
          }
        }
        else if (error.status === 302) {
          return throwError('Already have an open session.');
        }
        else if (error.status === 404) {
          return throwError(error.error);
        } else {
          return throwError(error.error || 'Sorry something went wrong on server');
        }
      }
    } else {
      return throwError('Please check your connection or try again later');
    }
  }


}
